export const RESEND_SR_WELCOME_EMAIL_MODAL_NAME =
  'RESEND_SR_WELCOME_EMAIL_MODAL_NAME';
